const actionType = {

  GET_FACILITY_LIST_SUCCESS : "GET_FACILITY_LIST_SUCCESS",
  GET_FACILITY_LIST_FAILURE : "GET_FACILITY_LIST_FAILURE",
  GET_NEW_FACILITY_LIST_SUCCESS : "GET_NEW_FACILITY_LIST_SUCCESS",
  GET_NEW_FACILITY_LIST_FAILURE : "GET_NEW_FACILITY_LIST_FAILURE",
  FACILITY_REG_STATUS_CHANGE_SUCCESS : "FACILITY_REG_STATUS_CHANGE_SUCCESS",
  FACILITY_REG_STATUS_CHANGE_FAILURE : "FACILITY_REG_STATUS_CHANGE_FAILURE",
  GET_BAA_IMAGE_SUCCESS : "GET_BAA_IMAGE_SUCCESS",
  GET_BAA_IMAGE_FAILURE : "GET_BAA_IMAGE_FAILURE",
  FACILITY_REQUEST_STATUS_CHANGE_FAILURE :"FACILITY_REQUEST_STATUS_CHANGE_FAILURE",
  FACILITY_REQUEST_STATUS_CHANGE_SUCCESS : "FACILITY_REQUEST_STATUS_CHANGE_SUCCESS",
  RECORD_REQ_LIST_SUCCESS : "RECORD_REQ_LIST_SUCCESS",
  RECORD_REQ_LIST_FAILURE : "RECORD_REQ_LIST_FAILURE",
  INITIAL_FEDEX_TRACK : "INITIAL_FEDEX_TRACK",


  FINAL_COST_SUCCESS : "FINAL_COST_SUCCESS",
  FINAL_COST_FAILURE : "FINAL_COST_FAILURE",

  ASSIGN_EMPLOYEE_STATUS_SUCCESS : " ASSIGN_EMPLOYEE_STATUS_SUCCESS",
  ASSIGN_EMPLOYEE_STATUS_FAILURE : " ASSIGN_EMPLOYEE_STATUS_FAILURE",

  FEDEX_TRACKING_SUCCESS : "FEDEX_TRACKING_SUCCESS",
  FEDEX_TRACKING_FAILURE : "FEDEX_TRACKING_FAILURE",
  FEDEX_STATUS_CHANGE  : "FEDEX_STATUS_CHANGE",

  CHECK_FAXSTATUS_SUCCESS : "CHECK_FAXSTATUS_SUCCESS",
  CHECK_FAXSTATUS_FAILURE : "CHECK_FAXSTATUS_FAILURE",
  FAX_STATUS_CHANGE: "FAX_STATUS_CHANGE",

  DOWNLOAD_RECORDS_SUCCESS :"DOWNLOAD_RECORDS_SUCCESS",
  DOWNLOAD_RECORDS_FAILURE:"DOWNLOAD_RECORDS_FAILURE",
  DOWNLOAD_STATUS_CHANGE : "DOWNLOAD_STATUS_CHANGE",

  FAX_RESEND_SUCCESS: "FAX_RESEND_SUCCESS",
  FAX_RESEND_FAILURE: "FAX_RESEND_FAILURE",

  FACILITY_EMR_LIST_SUCCESS:"FACILITY_EMR_LIST_SUCCESS",
  FACILITY_EMR_LIST_FAILURE:"FACILITY_EMR_LIST_FAILURE",

  FINALCOST_FOR_VIEW_SUCCESS:"FINALCOST_FOR_VIEW_SUCCESS",
  FINALCOST_FOR_VIEW_FAILURE:"FINALCOST_FOR_VIEW_FAILURE",

  REFRESH_COST_STATUS_FALSE :"REFRESH_COST_STATUS_FALSE",
  ADMIN_EDIT_COST_DETAILS_SUCCESS : "ADMIN_EDIT_COST_DETAILS_SUCCESS",
  ADMIN_EDIT_COST_DETAILS_FAILURE : "ADMIN_EDIT_COST_DETAILS_FAILURE"

  };
  export default actionType;
   